import React from 'react';
import { useTheme } from '@material-ui/core';
import { Stack } from '@mui/material';
import { VTypography } from '@venti-components';
import IconButton from '../../../../Components/Buttons/IconButton/IconButton';
import MaterialIcon from '../../../../Venti-UI-Kit/VIcon/MaterialIcon';
import { translate } from '../../../../utils/translate';
import ConfirmModal from '../../../../Venti-UI-Kit/Modals/ConfirmModal';
import { useDraggableRecommendationListItem } from './hook';

const DraggableRecommendationListItem = (props) => {
  const theme = useTheme();
  const { visibility, type, title, id } = props.list;
  const { openModal, handleCloseModal, handleAccept, handleDeleteList } =
    useDraggableRecommendationListItem(props);

  return (
    <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
      <Stack>
        <VTypography variant="subtitle3">{title}</VTypography>
        <VTypography variant="subtitle6">{translate(type)}</VTypography>
      </Stack>
      <Stack direction="row" gap={1} alignItems="center">
        <MaterialIcon
          name={visibility === 'active' ? 'visibility' : 'visibility_off'}
          color={visibility === 'active' ? theme.palette.primary.main : theme.palette.grey.main}
        />
        <IconButton
          Icon={<MaterialIcon name="edit" />}
          href={`/backoffice/admin/listasDeRecomendacion/editar/${id}`}
          variant="outlined"
        />
        <IconButton
          Icon={<MaterialIcon name="delete" color={theme.palette.error.main} />}
          onClick={handleDeleteList}
          variant="outlined"
          color={theme.palette.error.main}
        />
      </Stack>

      <ConfirmModal
        title="Eliminar Lista de Recomendación"
        subtitle={`¿Estás seguro de que querés eliminar la lista de recomendación ${title}?`}
        open={openModal}
        handleClose={handleCloseModal}
        handleAccept={handleAccept}
        acceptLabel="Eliminar"
      />
    </Stack>
  );
};

export default DraggableRecommendationListItem;
